import type { AssertAllRoutesAreDefined, RouteDefinition } from './routes.types'

export const routes = {
  Home: { to: '/' },
  DeeplinkValidation: {
    to: '/$product/$protocol',
    id: '/_main/$product/$protocol',
  },
  InvalidLinkError: { id: '/_main/invalid-link', to: '/invalid-link' },
  ApSetup: { id: '/_ems/emsi/safari', to: '/emsi/safari' },
} as const satisfies Record<string, RouteDefinition>

// This will error if you register a new route, but forget to add it to the routes list
// If only this was a part of the router itself.. https://github.com/TanStack/router/discussions/5893
export const exhaustiveCheck: AssertAllRoutesAreDefined<typeof routes> = true
